import { FC } from 'react';
import { ExportOutlined } from '@ant-design/icons';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';

/** 导出按钮 */
const ExportButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

ExportButton.defaultProps = {
  icon: <ExportOutlined />,
  text: '导出',
};

export default ExportButton;
